import { render, staticRenderFns } from "./DashboardSidebarFollowings.vue?vue&type=template&id=d18ab814"
import script from "./DashboardSidebarFollowings.vue?vue&type=script&lang=js"
export * from "./DashboardSidebarFollowings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports